import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { Text } from 'foundations-components/components/Text';
import { TABS } from 'collaboration-sidebar/constants/tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ZIndexWrapper = styled.div.withConfig({
  displayName: "Tab__ZIndexWrapper",
  componentId: "sc-7xtvw3-0"
})([".hs-private.hs-private.hs-private &{z-index:", ";flex-grow:0;}"], ({
  $zIndex
}) => $zIndex);
export default function Tab({
  heading,
  actions,
  children,
  showHeader = true,
  tab
}) {
  return /*#__PURE__*/_jsxs(Flex, {
    blockSize: "100%",
    flexDirection: "column",
    alignItems: "stretch",
    children: [showHeader &&
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ZIndexWrapper, {
      $zIndex: tab === TABS.COMMENTS ? 1200 : undefined,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        padding: "400",
        flexGrow: 0,
        borderBlockEndWidth: "100",
        borderBlockEndStyle: "solid",
        borderBlockEndColor: "border-core-default"
        /* ensure actions don't create inconsistent height */,
        minBlockSize: "64px",
        backgroundColor: tab === TABS.COMMENTS ? 'fill-surface-default' : undefined,
        children: [/*#__PURE__*/_jsx(Box, {
          flexGrow: 1,
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-300",
            children: heading
          })
        }), actions]
      })
    }), /*#__PURE__*/_jsx(Box, {
      grow: 1,
      minBlockSize: "0%",
      overflowY: "auto",
      position: "relative",
      children: children
    })]
  });
}